/**
 * Kinésithérapie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: (none — canonical scope without a legacy code)
 * Catalogue acts (NGAP Maroc): 23
 */
import { defineSpecialty } from "../types";

export const kinesitherapie = defineSpecialty(
{
  "id": "kinesitherapie",
  "label": "Kinésithérapie",
  "short": "Kiné.",
  "scope": "Rééducation fonctionnelle",
  "aliases": [],
  "doctorSpecs": [
    "Kinésithérapie"
  ],
  "featureFlag": "ux.v2.kinesitherapie",
  "theme": {
    "primary": "oklch(0.75 0.13 155)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.80 0.15 100)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "assessment",
      "label": "Bilan",
      "icon": "ClipboardCheck",
      "route": "/clinical/assessment",
      "order": 2,
      "requires": [
        "kine"
      ]
    },
    {
      "id": "sessions",
      "label": "Séances",
      "icon": "Activity",
      "route": "/clinical/sessions",
      "order": 3,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 4,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "assessment",
      "label": "Bilan",
      "icon": "ClipboardCheck",
      "component": "KineAssessment",
      "order": 1,
      "requires": []
    },
    {
      "id": "sessions",
      "label": "Séances",
      "icon": "Activity",
      "component": "SessionList",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Kinésithérapie",
    "subSpecialties": [
      "Consultation",
      "Séance de kinésithérapie",
      "Rééducation"
    ],
    "catalogueActs": 23
  },
  "terminology": {
    "icd10": [
      "Z50",
      "M54",
      "M25"
    ],
    "loinc": [
      "41848-8"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "pressure-gauge",
    "goniometer-digital"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default kinesitherapie;
